module.exports = "../images/testimonials-bg-cabin.jpg?v=eb59543";